
type MaybeNavigationMenu = NavigationMenu | undefined;

export function findNavigationByType (nav_menus: readonly NavigationMenu[], ...types: string[]): MaybeNavigationMenu[] {
  return types.reduce((acc: MaybeNavigationMenu[], type, index) => {
    acc[index] = nav_menus.find(x => x.navigationType == type);
    return acc;
  }, Array(types.length))
}

type NavItemFilter = (nav_item: NavigationMenuItem) => boolean;

export function filterExcluded (locale: string): NavItemFilter {
  return nav_item => !nav_item.excluded_locales?.some(x => x == locale);
}
